export {};
//# sourceMappingURL=patient-hub-claims.interface.js.map